import { useState } from "react"
import { Modal, ModalId, RadioField, option } from "../../../../features/ui"
import { NoteGenerationType } from "../types"

export const noteOptions = [
    option(NoteGenerationType.CREDIT_NOTE, 'Nota de Crédito ARCA'),
    option(NoteGenerationType.ADJUSTMENT_NOTE, 'Nota de Crédito')
]

type Props = {
    onConfirm: (noteType: NoteGenerationType) => void
}

// Only shown when the operation was invoiced: in that case the ARCA credit note is the default option
export const GenerateNoteModal = (props: Props) => {
    const { onConfirm } = props

    const [noteType, setNoteType] = useState<NoteGenerationType>(NoteGenerationType.CREDIT_NOTE)

    const onChange = (value?: string) => setNoteType(value as NoteGenerationType)

    const onSubmit = () => onConfirm(noteType)

    return (
        <Modal
            modalId={ModalId.GENERATE_NOTE}
            title="Generar Nota de Crédito"
            submitLabel="Confirmar"
            onSubmit={onSubmit}
        >
            <RadioField
                id="note-type"
                value={noteType}
                options={noteOptions}
                onChange={onChange}
            />
        </Modal>
    )
}
